module.exports = __webpack_public_path__ + "img/logo-long.b35e34f7.png";